let ecSnackBarTimeoutHandle;

function showEcAddToCartSnackbar() {
  var x = document.getElementById("ec-add-to-cart-snackbar");
  x.className = "show";
  ecSnackBarTimeoutHandle = setTimeout(function () {
    x.className = x.className.replace("show", "");
  }, 5000);
}

function addToCart(event, productFormId) {
  event.preventDefault();
  jQuery
    .ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/add.js",
      data: $(productFormId).serialize(),
      dataType: "json",
    })
    .done(() => {
      document.dispatchEvent(new CustomEvent("cart:build"));
      document.dispatchEvent(new CustomEvent("cart:open"));
      //clearTimeout(ecSnackBarTimeoutHandle);
      //showEcAddToCartSnackbar();
    });
}




function btcUpsells() { 
    var productid = $(".cart__item:first").data("pid");
  if(productid !== undefined || typeof productid !== "undefined" ) {
fetch(window.Shopify.routes.root + "recommendations/products.json?product_id="+productid+"&limit=2&intent=related")
  .then(response => response.json())
  .then(({ products }) => {
    if (products.length > 0) {
         $("#drwr_recommi").empty();
       for(var product in products){
        //console.log(product);
         
         prodt = products[product];
         if (prodt.title.indexOf("Off") < 0) {
           var litt = "<li class='drwr_recomp clearfix drwr_recomp-"+ product +"'><img src='" + prodt.featured_image + "'> <div class='drwr_recompm'><a href='" + prodt.url + "'><h4 class='text-capitalize'>" + prodt.title + " <span class='vartshst-"+ prodt.variants[0].title +"'>"+ prodt.variants[0].title +"</span></h4></a><p>$"+ parseFloat(prodt.price/100).toFixed(2) +"</p></div><div class='drwr_recompb'><a onclick='Shopify.addItembUpsell("+ prodt.variants[0].id +",1);' class='btn'>Add</a></div><div class='cb'></div></li>";
          // alert(prodt.variants[0].id);
           $("#drwr_recommi").append(litt);  
         }
           
        }
      }
    }
  ); 
}  
}
document.addEventListener("DOMContentLoaded",  btcUpsells() );

var acc = document.getElementsByClassName("ccx-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("ccx-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}
$(document).ready(function() {
    $('#drwr_ncheck').change(function() {
        if($(this).is(":checked")) {
             console.log("checked");
          $(".drwr_gift_note").show();
        } else {
            console.log("not checked");
           $(".drwr_gift_note").hide();
        }
              
    });

  $("input[name='attributes[is_gift]'").change(function() {
      var gCard = $(this).val();
 
       window.fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            attributes: {
                is_gift: $(this).val()
            }
        })
    });
     
    });

  
});

 